import truck from "../../../public/assets/truck.png";
import background from "../../../public/assets/background.png";
import background1024 from "../../../public/assets/backGround1024.png";
import backgroundNoPeople from "../../../public/assets/backgroundNoPeople.png";

import { quoteContext } from "../../context/quotesContext";
import { useContext } from "react";

import "./styles.css";
import { useTranslation } from "react-i18next";
import { Footer } from "./Footer";


export const HomeLayout = ({ children, showSteps }) => {
  const { isFristStepComplete, currentStep } = useContext(quoteContext);
  const [t, i18n] = useTranslation();

  return (
    <>
      <img className="img-truck" src={truck} />
      <div className="form-container">
        <h2 className="login-title">{t('login_for_quick_quote')}</h2>
        <div className="container">
          {showSteps && (
            <>
              <div className="form-steps">
                <div className="step-container">
                  <span
                    className={`step-number ${
                      (currentStep == 1 || isFristStepComplete) && "active"
                    }`}
                  >
                    1
                  </span>
                  <span
                    className={`step-label ${
                      (currentStep == 1 || isFristStepComplete) && "active"
                    }`}
                  >
                    {t('origen_destino')} 
                  </span>
                </div>
                <div className="line"></div>
                <div className="step-container">
                  <span
                    className={`step-number ${currentStep == 2 && "active"}`}
                  >
                    2
                  </span>
                  <span
                    className={`step-label ${currentStep == 2 && "active"}`}
                  >
                    {t('payment_details')}
                  </span>
                </div>
              </div>
            </>
          )}

          <div className="form-group">
            {children}
          </div>
        </div>
      </div>
      <div className="backgrounbd-container">
        <img className="img-background" src={background} />
        <img className="img-background backgroundMid" src={background1024} />
        <img
          className="img-background backgroundNoPeople"
          src={backgroundNoPeople}
        />
      </div>
      <Footer></Footer>
    </>
  );
};
